var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.184,
    height: 14.186,
    viewBox: "0 0 14.184 14.186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "phone",
    d: "M13.988,11.8l-2,1.984a1.447,1.447,0,0,1-1.067.406,9.25,9.25,0,0,1-4.586-1.728A17.69,17.69,0,0,1,.981,6.618,7.555,7.555,0,0,1,0,3.289,1.456,1.456,0,0,1,.409,2.207l2-2a.662.662,0,0,1,1.083.18L5.1,3.439a.886.886,0,0,1-.18,1.007l-.737.736a.363.363,0,0,0-.075.21A6.281,6.281,0,0,0,6,8.189a6.284,6.284,0,0,0,2.624,1.856.416.416,0,0,0,.383-.037l.857-.872a.978.978,0,0,1,1.037-.15h.015l2.9,1.713a.7.7,0,0,1,.165,1.1Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.2d402c2808ba1757e0f5f6fcbffd1c8b.svg";
export { ForwardRef as ReactComponent };